<div class="center-screen">
    <router-outlet></router-outlet>
</div>